<template>
  <div class="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>客户心愿单</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-notebook-2"
          @click="SelectdisplayitemDialog = true"
          >选择显示项</el-button
        >
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="search"
          >查询</el-button
        >
        <el-button v-if="jurisdiction.search" @click="eliminate"
          >清除查询条件</el-button
        >
        <el-button v-if="jurisdiction.export" @click="exportShow = true"
          >导出</el-button
        >
        <el-button
          v-if="jurisdiction.export"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>
    <!-- 首页查询card -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="140px" :model="Inquirycard" size="small">
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域">
                <el-select
                  style="width: 50%"
                  v-model="Inquirycard.regionIds"
                  multiple
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-col>
                <el-form-item label="卡号\电话号码\姓名">
                  <el-input
                    style="width: 50%"
                    v-model="Inquirycard.cusInfo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="心愿单">
                  <el-input
                    style="width: 50%"
                    v-model="Inquirycard.wishProduct"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="创建日期">
                  <el-date-picker
                    style="width: 50%"
                    v-model="Inquirycard.datePicker"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="16">
                <el-form-item label="门店">
                  <textarea
                    style="width: 85%"
                    rows="6"
                    readonly
                    v-model="Inquirycard.listOfSomeStoreslStr"
                  ></textarea>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button style="margin-left: -30px" @click="selectstore"
                  >选择门店</el-button
                >
              </el-col>
              <el-col>
                <el-form-item label="是否购买">
                  <el-select style="width: 50%" v-model="Inquirycard.isBuy">
                    <el-option label="所有" value=""></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div>
      <!-- 首页列表内容 -->
      <el-card shadow="never" class="centercard">
        <el-table
          :key="key"
          size="small"
          class="table-style"
          :height="isMore ? 'calc(100vh - 33.3rem)' : 'calc(100vh - 31rem)'"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="Customerwishlist"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column
            v-for="(item, index) in formThead"
            :key="index"
            :label="item.titleName"
            :prop="item.fieldName"
          ></el-table-column>
          <!-- <el-table-column prop="custName" label="客户姓名"></el-table-column>
          <el-table-column prop="cardNo" label="会员卡号"></el-table-column>
          <el-table-column prop="level" label="级别"></el-table-column>
          <el-table-column prop="shopCode" label="维护店编号"></el-table-column>
          <el-table-column prop="wishProduct" label="心愿单"></el-table-column>
          <el-table-column
            prop="lastSaleAmt"
            label="最近购买金额"
          ></el-table-column>
          <el-table-column prop="createTime" label="登记日期">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime !== null">
                {{ scope.row.createTime | dateFormat }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="firstSaleID"
            label="首次购买销售单"
          ></el-table-column> -->
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <!-- 选择门店弹窗 -->
    <div class="outlet">
      <el-dialog
        :close-on-click-modal="false"
        width="30%"
        :visible.sync="outletVisible"
        title="选择门店"
      >
        <el-form size="mini" label-width="90px">
          <el-row
            :gutter="50"
            v-for="(item, index) in StoreSelectionList"
            :key="index"
          >
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="shopID"
                highlight-current
                default-expand-all
                :default-checked-keys="xuanzhong"
                :props="defaultProps"
              ></el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出客户心愿单记录"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>客户心愿单记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载文件"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 选择显示列弹窗 -->
    <div>
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="显示项"
        :visible.sync="SelectdisplayitemDialog"
      >
        <el-row :gutter="20">
          <el-col
            v-for="(item, index) in Selectdisplayitem"
            :key="index"
            :span="6"
          >
            <el-checkbox-group
              @change="handleCheckedCitiesChange"
              v-model="Selectdisplayiteme"
            >
              <el-checkbox :label="item.ID">{{ item.titleName }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectfinish">选择完成</el-button>
          <el-button @click="Restoredefault">恢复默认选项</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  RegionApi,
  reportcustwishlistApi,
  reportFormList,
  reportcustwishlistExport,
  ReportgetdisplayfiledApi,
} from "@/api/reportForm";
import { dateTimes } from "@/utils/auth";
export default {
  name: "CustomerwishlistForm",
  data() {
    return {
      //
      formThead: [],
      key: "",
      ID1: "",
      Selectdisplayitem: [],
      Selectdisplayiteme: [],
      SelectdisplayitemDialog: false,

      jurisdiction: {
        search: false,
        export: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      Inquirycard: {
        displayFiled: [],
        listOfSomeStoreslStr: "", // 门店
        listOfSomeStoresl: [],
        beginDate: "",
        endDate: "",
        regionIds: [],
        cusInfo: "",
        wishProduct: "",
        isBuy: "",
        shopIds: [],
        datePicker: "",
        pageNum: 1,
        pageSize: 50,
        pages: 0,
      },
      regionList: [],
      outletVisible: false,
      //   选择门店数据
      xuanzhong: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      Customerwishlist: [], // 客户心愿单列表
      loading: false,
      exportShow: false,
      downloadData: [],
      downloadShow: false,
    };
  },
  created() {
    this.Reportgetdisplayfiled();
    this.regionSelectList();
    this.ShopqueryRegionList();
    let CustomerwishlistForm = JSON.parse(
      localStorage.getItem("CustomerwishlistForm")
    );
    console.log(CustomerwishlistForm);
    for (let i = 0; i < CustomerwishlistForm.length; i++) {
      if (CustomerwishlistForm[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (CustomerwishlistForm[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
  },
  computed: {
    isMore() {
      return this.Inquirycard.pageNum >= this.Inquirycard.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    // 选择完成
    Selectfinish() {
      this.Inquirycard.displayFiled = this.ID1;
      this.Customerwishlist = [];
      this.Inquirycard.pageNum = 1;
      this.getCustomerwishlist();
      this.loading = true;
      this.formThead = this.Selectdisplayitem.filter(
        (i) => this.ID1.indexOf(i.ID) >= 0
      );
      this.key = this.key + 1;
      this.SelectdisplayitemDialog = false;
    },
    // 恢复默认选项
    Restoredefault() {
      this.Selectdisplayiteme = [];
      this.Reportgetdisplayfiled();
      this.Customerwishlist = [];
      this.Inquirycard.pageNum = 1;
      console.log("恢复", this.Inquirycard.displayFiled);
      this.loading = true;
      this.$message.success("恢复默认选项成功!");
      this.SelectdisplayitemDialog = false;
    },
    // 显示项checkbox点击获值
    handleCheckedCitiesChange(val) {
      this.ID1 = val;
      console.log(val);
    },
    // 获取显示项
    Reportgetdisplayfiled() {
      ReportgetdisplayfiledApi({ reportId: 1003 }).then((res) => {
        if (res.success == true) {
          this.formThead = [];
          this.key = this.key + 1;
          this.Selectdisplayitem = res.data;
          // 判断是否默认选项
          this.Selectdisplayitem.forEach((item) => {
            if (item.IsDefault == true) {
              this.Selectdisplayiteme.push(item.ID);
              this.ID1 = this.Selectdisplayiteme;
              this.Inquirycard.displayFiled = this.Selectdisplayiteme;
              console.log(this.Inquirycard.displayFiled);
              this.formThead.push(item);
            }
          });
          this.getCustomerwishlist();
        }
      });
    },
    // 获取下载列表数据
    getDownladList() {
      reportFormList({ groupName: "客户心愿单" }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 导出
    Export() {
      if (
        this.Inquirycard.datePicker &&
        this.Inquirycard.datePicker.length > 0
      ) {
        this.Inquirycard.beginDate = dateTimes(this.Inquirycard.datePicker[0]);
        this.Inquirycard.endDate = dateTimes(this.Inquirycard.datePicker[1]);
      } else {
        this.Inquirycard.beginDate = undefined;
        this.Inquirycard.endDate = undefined;
      }
      let shopID = [];
      if (this.Inquirycard.listOfSomeStoresl.length > 0) {
        //
        this.Inquirycard.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        displayFiled: this.Inquirycard.displayFiled,
        beginDate: this.Inquirycard.beginDate,
        endDate: this.Inquirycard.endDate,
        regionIds:
          this.Inquirycard.regionIds.length == 0
            ? undefined
            : this.Inquirycard.regionIds,
        cusInfo:
          this.Inquirycard.cusInfo == "" ? undefined : this.Inquirycard.cusInfo,
        wishProduct:
          this.Inquirycard.wishProduct == ""
            ? undefined
            : this.Inquirycard.wishProduct,
        isBuy:
          this.Inquirycard.isBuy == "" ? undefined : this.Inquirycard.isBuy,
        shopIds: shopID.length == 0 ? undefined : shopID,
      };
      reportcustwishlistExport(data).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看!");
      });
    },
    // 清除查询条件
    eliminate() {
      this.Inquirycard = {
        displayFiled: this.Inquirycard.displayFiled,
        listOfSomeStoreslStr: "",
        listOfSomeStoresl: [],
        beginDate: "",
        endDate: "",
        regionIds: [],
        cusInfo: "",
        wishProduct: "",
        isBuy: "",
        shopIds: [],
        datePicker: [],
        pageNum: 1,
        pageSize: 50,
        pages: 0,
      };
      this.Customerwishlist = [];
      this.xuanzhong = [];
      this.$message.success("清除查询条件成功!");
      this.getCustomerwishlist();
    },
    // 查询
    search() {
      this.Inquirycard.pageNum=1;
      this.loading = true;
      if (
        this.Inquirycard.datePicker &&
        this.Inquirycard.datePicker.length > 0
      ) {
        this.Inquirycard.beginDate = dateTimes(this.Inquirycard.datePicker[0]);
        this.Inquirycard.endDate = dateTimes(this.Inquirycard.datePicker[1]);
      } else {
        this.Inquirycard.beginDate = undefined;
        this.Inquirycard.endDate = undefined;
      }
      let shopID = [];
      if (this.Inquirycard.listOfSomeStoresl.length > 0) {
        this.Inquirycard.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        pageNum: this.Inquirycard.pageNum,
        pageSize: this.Inquirycard.pageSize,
        displayFiled: this.Inquirycard.displayFiled,
        // pages: this.Inquirycard.pages,
        beginDate: this.Inquirycard.beginDate,
        endDate: this.Inquirycard.endDate,
        regionIds:
          this.Inquirycard.regionIds.length == 0
            ? undefined
            : this.Inquirycard.regionIds,
        cusInfo:
          this.Inquirycard.cusInfo == "" ? undefined : this.Inquirycard.cusInfo,
        wishProduct:
          this.Inquirycard.wishProduct == ""
            ? undefined
            : this.Inquirycard.wishProduct,
        isBuy:
          this.Inquirycard.isBuy == "" ? undefined : this.Inquirycard.isBuy,
        shopIds: shopID.length == 0 ? undefined : shopID,
      };
      reportcustwishlistApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询列表失败!");
          // this.loading = false;
          return;
        } else {
          res.data.list.forEach((item) => {
            item.createTime = dateTimes(item.createTime);
          });
          this.Customerwishlist = res.data.list;
          this.Inquirycard.pages = res.data.pages;
          this.loading = false;
          this.$message.success("查询列表成功!");
        }
      });
    },
    // 首页列表
    getCustomerwishlist() {
      if (
        this.Inquirycard.datePicker &&
        this.Inquirycard.datePicker.length > 0
      ) {
        this.Inquirycard.beginDate = dateTimes(this.Inquirycard.datePicker[0]);
        this.Inquirycard.endDate = dateTimes(this.Inquirycard.datePicker[1]);
      } else {
        this.Inquirycard.beginDate = undefined;
        this.Inquirycard.endDate = undefined;
      }
      let shopID = [];
      if (this.Inquirycard.listOfSomeStoresl.length > 0) {
        //
        this.Inquirycard.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        pageNum: this.Inquirycard.pageNum,
        pageSize: this.Inquirycard.pageSize,
        displayFiled: this.Inquirycard.displayFiled,
        // pages: this.Inquirycard.pages,
        beginDate: this.Inquirycard.beginDate,
        endDate: this.Inquirycard.endDate,
        regionIds:
          this.Inquirycard.regionIds.length == 0
            ? undefined
            : this.Inquirycard.regionIds,
        cusInfo:
          this.Inquirycard.cusInfo == "" ? undefined : this.Inquirycard.cusInfo,
        wishProduct:
          this.Inquirycard.wishProduct == ""
            ? undefined
            : this.Inquirycard.wishProduct,
        isBuy:
          this.Inquirycard.isBuy == "" ? undefined : this.Inquirycard.isBuy,
        shopIds: shopID.length == 0 ? undefined : shopID,
      };
      reportcustwishlistApi(data).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            item.createTime = dateTimes(item.createTime);
          });
        }
        if (this.Inquirycard.pageNum == 1) this.Customerwishlist = [];
        this.Customerwishlist = this.Customerwishlist.concat(res.data.list);
        this.Inquirycard.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.Inquirycard.pageNum += 1;
        this.getCustomerwishlist();
      }, 1000);
    },
    // 选择门店确定事件
    ComButtomStore() {
      //获取已选择的门店数据
      this.Inquirycard.listOfSomeStoresl = [];
      this.Inquirycard.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.Inquirycard.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.Inquirycard.listOfSomeStoresl.push(...item);
        }
      }
      this.Inquirycard.listOfSomeStoresl.forEach((item) => {
        this.Inquirycard.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // this.queryInfo.listOfSomeStoreslStr =
      //   this.queryInfo.listOfSomeStoreslStr.substring(
      //     0,
      //     this.queryInfo.listOfSomeStoreslStr.length - 1
      //   );
      console.log(this.Inquirycard.listOfSomeStoreslStr.length);
      this.xuanzhong = [];
      for (let i = 0; i < this.Inquirycard.listOfSomeStoresl.length; i++) {
        this.xuanzhong.push(this.Inquirycard.listOfSomeStoresl[i].id);
      }
      // console.log(this.xuanzhong);
      this.outletVisible = false;
    },
    // 选择门店按纽
    selectstore() {
      this.outletVisible = true;
    },
    // 获取区域门店
    ShopqueryRegionList() {
      RegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 区域
    regionSelectList() {
      RegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);
        }
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
// 选择门店弹框样式
/deep/.outlet {
  .el-dialog__header {
    background-color: #f3f1dd;
  }
  .el-dialog__title {
    font-size: 14px;
    font-weight: 700;
    color: #6c6937;
  }
  .el-dialog__body {
    padding: 20px 10px 20px 10px;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }
  .el-button:hover {
    background-color: #b5b386;
    color: #f2f2f2;
  }
}
#alterations {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #fcfbf2;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 导出弹框样式
  .exporttc {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
      border-radius: 9px;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
    .el-dialog__wrapper {
      .el-dialog {
        border-radius: 9px;
      }
    }
  }
}
</style>
